import styled, { css } from "styled-components";

const NoItemsCTAStyled = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.activeTab === "receiving" ? "space-between" : "flex-start"};
  align-items: center;
  padding: 3.2rem 1.6rem;

	@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    height: 23rem;
		padding: 0 3.2rem;
    flex-direction: row;
  }

  p {
    font-size: 2.2rem;
    margin-bottom: 0;
    font-family: ${props => props.theme.fontBold};
    margin-bottom: 3.2rem;

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
      margin-right: 10rem;
      margin-bottom: 0;
      font-size: 2.6rem;
    }
  }

  .cta__buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    gap: 2.4rem;
    width: 100%;

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
      flex-direction: row;
      width: auto;
    }

    a {
      width: 100%;

      @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        width: auto;
      }
    }


    .btn {

      &--sending {
        color: #ffffff;
        border: 1px solid ${props => props.isBusiness ? props.theme.teal : props.theme.heritageGreen};
        background-color: ${props => props.isBusiness ? props.theme.teal : props.theme.heritageGreen};

          &:hover {
            background-color: ${props => props.isBusiness ? props.theme.lightTeal : props.theme.darkerGreen};
            border-color: ${props => props.isBusiness ? props.theme.lightTeal : props.theme.darkerGreen};
          }
      }

      &--return {
        background-color: transparent;
        color: #1B1E1C;
        border: 1px solid ${props => props.isBusiness ? props.theme.teal : props.theme.limeGreen};

        &:hover {
          border-color: ${props => props.isBusiness ? props.theme.lightTeal : props.theme.darkLimeGreen};
        }
      }
    }
  }
`;

export { NoItemsCTAStyled };